import { Component, OnInit } from '@angular/core';
import { SelectStatementOptions } from 'src/app/models/select-statement-options.model';
import { LoadingIndicationService } from 'src/app/services/loading-indication.service';
import { FiltersOperator } from 'src/app/widgets/filters/api/filters-operator.api';
import { ScenarioComparisonResult, ScenarioComparisonService, WeightedProp } from './scenario-comparison.service';

@Component({
    selector: 'app-scenario-comparison',
    templateUrl: './scenario-comparison.component.html',
    styleUrls: ['./scenario-comparison.component.scss'],
    standalone: false
})
export class ScenarioComparisonComponent implements OnInit {

	constructor(
		private scenarioComparisonService: ScenarioComparisonService
	) { }

  public scenarios: ScenarioComparisonResult;
  public metrics: string[] = [];
  public selectedMetric: string;
  public selectStatementAndSelectionSetIds: any;
  public filtersSelectStatementAndSelectionSetIds: any;
  public propList: WeightedProp[] = [];

  public scenariosFiltersOperator: FiltersOperator = new FiltersOperator(
    new SelectStatementOptions(
			{
				baseSelectStatementId: 10037,
				selectionSetId: 110
			}
		)
  );

  ngOnInit(): void {
    let $this = this;

    this.scenarioComparisonService.getAllMetrics().subscribe(res => {
      $this.metrics = res;
      $this.selectedMetric = $this.metrics[0];

      this.scenarioComparisonService.getFilterSelectStatementAndSelectionSetIdsByMetric(this.selectedMetric).subscribe(res => {
        this.filtersSelectStatementAndSelectionSetIds = res;

        this.scenariosFiltersOperator = new FiltersOperator(
          new SelectStatementOptions(
						{
							baseSelectStatementId: this.filtersSelectStatementAndSelectionSetIds.item1,
							selectionSetId: this.filtersSelectStatementAndSelectionSetIds.item2
						}
					)
        );

        this.scenariosFiltersOperator.load();
        this.scenariosFiltersOperator.onFiltersApplied.subscribe({
          next: (res) => {
            this.scenariosFiltersOperator.load();
            this.getData();
          }
        });
      });

      this.getData();
    });
  }

  public getData() {
    let $this = this;

    $this.scenarioComparisonService.getSelectStatementAndSelectionSetIdsByMetric($this.selectedMetric).subscribe(res => {
      $this.selectStatementAndSelectionSetIds = res;

      this.scenarioComparisonService.getScenarioComparisonData(this.selectStatementAndSelectionSetIds.item1,
        this.selectStatementAndSelectionSetIds.item2, this.scenariosFiltersOperator.appliedFilters).subscribe(res => {
          $this.scenarios = res;
          const dataSample = $this.scenarios.scenarioData.data[0];

          for (const prop in dataSample) {
            const index = $this.propList.findIndex(x => x.propName == prop);

            if (index == -1 && prop !== 'Percentage')
              $this.propList.push({ propName: prop, weight: 0, positiveIsGood: true });
          }

          for (const prop in $this.scenarios.scenarioPercentageRelation) {
            const scnearioIndex = $this.scenarios.scenarioData.data.findIndex(x => x.ScenarioName == prop);

            if (scnearioIndex != null && scnearioIndex != undefined) {
              $this.scenarios.scenarioData.data[scnearioIndex].Percentage = $this.scenarios.scenarioPercentageRelation[prop];
            }
          }

          $this.scenarios.scenarioData.data.forEach(x => {
            if (x.AvgPrice)
              x.AvgPrice = +x.AvgPrice.toPrecision(4);
          });

          $this.scenarios.scenarioData.data.sort((a, b) => {
            if (a.Percentage > b.Percentage) {
              return -1;
            }

            if (a.Percentage < b.Percentage) {
              return 1;
            }

            return 0;
          });

          this.scenarioComparisonService.getMetricDefinitionsByMetricName(this.selectedMetric).subscribe(res => {
            this.propList.forEach(x => {
              const index = res.findIndex(y => y.keyFigure === x.propName);
              if (index != -1) {
                x.weight = res[index].weight;
                x.positiveIsGood = res[index].positiveIsGood;
              }
            });
          });
        });
    });
  }

  public onMetricsChanged($event) {
    this.selectedMetric = $event.selectedItem;
    this.propList = [];

    this.scenarioComparisonService.getFilterSelectStatementAndSelectionSetIdsByMetric(this.selectedMetric).subscribe(res => {
      this.filtersSelectStatementAndSelectionSetIds = res;

      this.scenariosFiltersOperator = new FiltersOperator(
        new SelectStatementOptions(
					{
						baseSelectStatementId: this.filtersSelectStatementAndSelectionSetIds.item1,
						selectionSetId: this.filtersSelectStatementAndSelectionSetIds.item2
					}
				)
      );

      this.scenariosFiltersOperator.load();
      this.scenariosFiltersOperator.onFiltersApplied.subscribe({
        next: (res) => {
          this.scenariosFiltersOperator.load();
          this.getData();
        }
      });
    });

    this.getData();
  }
}
